import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Home.css';
import entitiesData from '../data/entities.json';
import interactivemap from '../assets/interactivemap2.png';
import summary from '../assets/summary.png';


const Home = () => {
    const [welcomeText, setWelcomeText] = useState('');
    const [showSidebar, setShowSidebar] = useState(false);

    useEffect(() => {
        setWelcomeText(entitiesData.welcomeText);
    }, []);

    const toggleSidebar = () => {
        setShowSidebar(prev => !prev);
    };

    return (
        <div className="home">
            {/* --- Floating Ribbon Button (ALWAYS outside of card-row) --- */}
            <div className="ribbon-container" onClick={toggleSidebar}>
                <div className="ribbon-text">Fun Facts</div>
                <div
                    className={`ribbon-arrow ${showSidebar ? 'rotate-left' : 'rotate-right'}`}
                    dangerouslySetInnerHTML={{ __html: '&#10148;' }}
                />
            </div>

            {/* --- Card Row (Sidebar + Welcome Card) --- */}
            <div className={`card-row ${showSidebar ? 'expanded' : ''}`}>

                {/* Sidebar: only shown when expanded */}
                {showSidebar && (
                    <div className="side-card">
                        <h3 className="fun-facts-header">Alaska Fun Facts</h3>

                        <p><strong>Statehood:</strong> Alaska officially became the 49th state of the United States on January 3, 1959, after over 50 years as a U.S. territory. Over 80% of voters approved statehood in a 1958 referendum.</p>

                        <p><strong>Largest State:</strong> Alaska is about a fifth of the size of the entire contiguous United States, covering an estimated 663,267 square miles. To put it in perspective, Alaska is approximately 7 times smaller than the entire United States, and about 16 times smaller than North America. It is over twice the size of Texas and spans from Maine to Florida and west to Tennessee.</p>

                        <p><strong>Remote Ballots:</strong> Some Alaskan ballots are delivered and collected by bush plane, boat, or snowmachines to reach remote communities during elections.</p>

                        <p><strong>Electoral Votes:</strong> Despite its enormous land area, Alaska has only 3 electoral votes — the minimum for any state — due to its relatively small population of about 730,000 people.</p>

                        <p><strong>Ranked Choice Voting:</strong> In 2020, Alaska voters approved Ballot Measure 2, adopting Ranked Choice Voting for state and federal elections. The new system was first used in 2022.</p>

                        <p><strong>Multilingual Ballots:</strong> Under the Voting Rights Act, Alaska offers translation of voting materials in English, and multiple Alaska Native languages, including 6 Yup’ik dialexts,and Inupiaq.</p>

                        <p><strong>Independent Voters:</strong> Nearly 58% of Alaska’s registered voters are either nonpartisan or undeclared — one of the highest rates of independent registration in the nation.</p>

                        <p><strong>Time Zones:</strong> Alaska used to have four time zones, but today most of the state operates on Alaska Standard Time, while the western Aleutian Islands use Hawaii-Aleutian Time.</p>

                        <p><strong>Ballot Collection Time:</strong> Rural precincts can officially take up to 10 full days after Election Day to send all ballots and complete official counts due to extreme travel conditions.</p>

                        <p><strong>First Female Governor:</strong> Alaska elected its first female governor, Sarah Palin, in 2006.</p>

                
                        <div className="important-links">
                            <h3 className="learn-more-header">Learn More</h3>
                            <ul className="alaska-icon-links">
                                <li>
                                    <a href="https://www.elections.alaska.gov/" target="_blank" rel="noopener noreferrer" className="alaska-icon-button blue-overlay">
                                        <span>Alaska Elections</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.elections.alaska.gov/Core/voterregistrationstatistics.php" target="_blank" rel="noopener noreferrer" className="alaska-icon-button orange-overlay">
                                        <span>Voter Statistics</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://myvoterportal.alaska.gov/" target="_blank" rel="noopener noreferrer" className="alaska-icon-button purple-overlay">
                                        <span>My Voter Portal</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.muni.org/Departments/Assembly/Clerk/Elections/Pages/ResultsAndHistory.aspx" target="_blank" rel="noopener noreferrer" className="alaska-icon-button teal-overlay">
                                        <span>Alaska Assembly</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                )}

                {/* Welcome Card */}
                <div className="welcome-card">
                    <h2>Welcome to BallotVision</h2>
                    <p className="welcome-subtext">
                        Explore millions of ballots from Alaska’s official Cast Vote Records.<br />
                        Search, visualize, and discover election trends across the entire state.
                    </p>

                    <Link to="/map">
                        <div className="featured-image-square">
                            <img src={interactivemap} alt="Interactive Map Preview" />
                        </div>
                    </Link>

                    <p className="image-caption">Explore election data through our interactive visualizations!</p>

                    <p className="intro-text">
                        This project was inspired by the implementation of Ranked Choice Voting in Alaska in 2020, and by the discovery that the State of Alaska makes
                        Cast Vote Record (CVR) files publicly available online. By parsing and organizing the raw CVR data, our application provides the public with a powerful, interactive way to explore and query real election results.
                        Our goal is to make Alaska’s CVR data accessible, searchable, and understandable to anyone.
                    </p>

                    <p className="image-caption">Check out our summary page and explore ballot data!</p>

                    <Link to="/summary-data">
                        <div className="featured-image-wide" style={{ marginTop: '20px' }}>
                            <img src={summary} alt="Summary Page Preview" />
                        </div>
                    </Link>

                    <p className="intro-text">
                        BallotVision's backend is already managing over <strong>12 million</strong> rows of election data — and we're only getting started.
                        Future updates will expand the ways users can visualize, explore, and understand election results like never before.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Home;

